<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { unitConverterMixin } from "@/mixins/management/unitConverterMixin";
export default {
  name: "MaterialFieldsFieldCable",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin, unitConverterMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },
    /**
     * Indicates if the fields should be disabled or not
     */
    disableFields: {
      type: Boolean
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
    };
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    fields() {
      return [
        {
          label: this.$i18n.t("Diameter") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smfc_diameter,
          varName: 'smfc_diameter',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '.01',
          min: '1',
        },
        {
          label: this.$i18n.t("IsInBOM"),
          value: this.familySpecificFields.smfc_used_in_bom ? "True" : "False",
          varName: 'smfc_used_in_bom',
          inputType: 'radio',
          disabled: false,
          required: true,
          radioOptions: [
            {
              label: this.$i18n.t("Yes"),
              value: "True",
            },
            {
              label: this.$i18n.t("No"),
              value: "False",
            }
          ]
        }
      ]
    },
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.smfc_diameter && this.familySpecificFields.smfc_diameter >= 1
      );
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsFieldCable.vue